import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { faCaretLeft, faCaretRight, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonUC from '../../../../components/buttonUC';
import { library } from '@fortawesome/fontawesome-svg-core'
import { ShareAltOutlined } from '@ant-design/icons';
import useHome from '../../context/useHome';
import { changeFormatdate } from '../../../../utils/formatDate';
import { useNavigate } from 'react-router-dom';
import SharedModal from '../../../../components/sharedModal';
import config from '../../../../config';
import homeLogo from '../../../../assets/images/header/logo.png'
import { Image, Tooltip } from 'antd';
import AIRibbon from '../../../../assets/images/ai/ribbon.png'

const Carousel = (props) => {
    const { jobRecommendAI } = props
    const sliderRef = useRef(null);
    const { orgUnitIdContext, cards } = useHome()
    const history = useNavigate()
    const [openModal, setOpenModal] = useState(false)
    const [dataModal, setDataModal] = useState(null)
    library.add(faHeart)

    const ArrowLeft = ({ onClick, ...props }) => (
        <button
            className='slick-bottom-prev'
            onClick={onClick}
            aria-hidden="true"
            aria-disabled={props.className.includes('slick-disabled') ? true : false} >
            <FontAwesomeIcon
                icon={faCaretLeft}
                className={(props.className.includes('slick-disabled') ? 'icon-disabled' : '')} />
        </button>
    );
    const ArrowRight = ({ onClick, ...props }) => (
        <button
            className='slick-bottom-next'
            onClick={onClick}
            aria-hidden="true"
            aria-disabled={props.className.includes('slick-disabled') ? true : false} >
            <FontAwesomeIcon
                icon={faCaretRight}
                className={(props.className.includes('slick-disabled') ? 'icon-disabled' : '')} />
        </button>
    );

    const Ribbon = ({ percentage }) => {
        return (
            <div className='absolute ribbon' style={{ left: '25px' }}>
                <div className="relative" style={{ display: 'inline-block' }}>
                    <Image
                        className="image-ai relative"
                        style={{ objectFit: "cover", zIndex: 1 }}
                        width={isMobile ? 40 : 46}
                        preview={false}
                        src={AIRibbon}
                    />
                    <div className='percentage absolute color-white'
                        style={{
                            top: '40%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2, fontSize: `${isMobile ? '12px' : '14px'}`
                        }}>
                        {`${percentage ?? 0}%`
                        }
                    </div>
                </div>
            </div >
        )
    }

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 1601,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 1370,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    // arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    // arrows: false,
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    // arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    // arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
        ],
        prevArrow: <ArrowLeft />,
        nextArrow: <ArrowRight />,
        className: 'slider-container',
        appendDots: dots => (
            <div>
                <ul>{dots}</ul>
                <div className="custom-arrows">
                    <ArrowLeft isDisabled={dots === 0} />
                    <ArrowRight isDisabled={dots === dots.length - 1} />
                </div>
            </div>
        ),
    };

    const handleShare = (data) => {
        console.log('handleShare', data)
        setDataModal(data)
        setOpenModal(true)
    }

    const handleCancelModal = () => {
        setOpenModal(false)
    }

    const handleClickShowDetail = (card) => {
        console.log('handleClickShowDetail', card)
        history(`/JobDetail/${card.orgUnitName ?? card.id}/${card.id}`)
    }

    const isMobile = window.innerWidth <= 768;

    const getLogoFromBu = (card) => {
        if (card && card.buCode && cards && cards.length > 0) {
            const _card = cards.find(c => c.orgUnitCode === card.buCode)
            if (_card) return `${config.wfAttachFileEndPoint}/${_card.logo}`
        }
        const _logo = orgUnitIdContext === '00' || !orgUnitIdContext ? homeLogo : (card?.logo ? `${config.wfAttachFileEndPoint}/${card?.logo}` : null)
        return _logo || homeLogo
    }

    const Card = ({ card }) => {
        const positionName = `${card.positionManageName ?? ''} ${card.positionCareerName ?? ''} ${card.empLevel ?? ''} ${card.wardName ?? ''} ${card.divisionName ?? ''} ${card.departmentName ?? ''} ${card.buName ?? ''}`
        return (
            <div className='div-card relative' >
                <Ribbon className='ai-ribbon' percentage={card.score} />
                <div className='card flex justify-start flex-col'>
                    <div className="div-card-image">
                        <img className='margin-auto'
                            // src={orgUnitIdContext === '00' || !orgUnitIdContext ? homeLogo : `${config.wfAttachFileEndPoint}/${card.logo}`}
                            src={card ? getLogoFromBu(card) : null}
                            // src={homeLogo}
                            alt={positionName} />
                    </div>
                    <Tooltip title={positionName} trigger={isMobile ? 'click' : 'hover'}>
                        <div className="card-title line-clamp-2" >{positionName}</div>
                    </Tooltip>
                    <div className="div-address flex flex-row">
                        {/* <FontAwesomeIcon icon={faLocationDot} className='fa-location mr-3' />
                        <div className="card-address line-clamp-2" title={card.address}>{card.address}</div> */}
                    </div>
                    <div className="div-detail">
                        <div className="open flex justify-center">
                            <div className="label">เปิดรับสมัคร</div>
                            <div className="open-date pl-1 ">{changeFormatdate(card.startDate)}</div>
                        </div>
                        <div className="close flex justify-center">
                            <div className="label">ปิดรับสมัคร</div>
                            <div className="close-date pl-1 ">{card.isNoEndDate === true ? '-' : changeFormatdate(card.endDate)}</div>
                        </div>
                    </div>
                    <div className="div-footer flex items-center justify-center">
                        <ButtonUC className='btn-detail btn-custom mr-4' onClick={() => handleClickShowDetail(card)}>ดูรายละเอียด</ButtonUC>
                        <div className='cursor-pointer' onClick={() => handleShare(card)}>
                            <ShareAltOutlined className='icon-footer' />
                        </div>
                    </div>
                </div>
                <div className="card-footer"></div>
            </div>
        )
    }

    return (
        <>
            {openModal &&
                <SharedModal
                    data={dataModal}
                    open={openModal}
                    handleCancel={handleCancelModal}
                />
            }
            <div className='scope2-carousel margin-auto'>
                <div className="carousel-wrapper">
                    {jobRecommendAI?.length > 0 &&
                        <Slider ref={sliderRef} {...settings}>
                            {jobRecommendAI.map((card, index) => (
                                <Card key={index} card={card} />
                            ))}
                        </Slider>
                    }
                </div>
            </div>
        </>
    );
};

export default Carousel;
